"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../../../index");
exports.fetchAdminProfile = function (usersub) {
    return index_1.Model.makeRequest("/auth/public/functions/fetch-admin-profile/" + usersub, index_1.METHOD.GET);
};
